module.exports = __webpack_public_path__ + "img/tom.421802d4.jpg";